import { useEffect, useState } from 'react';
import Header from '@/components/Header';
import { loadPapers, loadConfig } from '@/lib/data';
import { getArtifactTypes } from '@/lib/filters';

export default function AboutPage() {
  const [papers, setPapers] = useState(null);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    Promise.all([loadPapers(), loadConfig()]).then(([p, c]) => {
      setPapers(p);
      setConfig(c);
    });
  }, []);

  if (!papers || !config) {
    return (
      <div className="main-layout">
        <div className="loading">
          <div className="loading__spinner" />
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  const about = config.about || {};
  const counts = {};
  papers.forEach((p) => {
    getArtifactTypes(p).forEach((t) => {
      counts[t] = (counts[t] || 0) + 1;
    });
  });

  return (
    <div className="main-layout">
      <Header config={config} />
      <main className="main-content about-page">
        <h1>{about.title || 'About'}</h1>
        <p className="about-page__intro">{about.introduction}</p>

        {(config.typesOfArtifact || []).length > 0 && (
          <section className="detail-section">
            <h2 className="detail-section__title">Types of Artifact</h2>
            <ul className="about-page__inquiry-list">
              {config.typesOfArtifact.map((t) => (
                <li key={t.id} className="about-page__inquiry-item">
                  <span className="inquiry-card__swatch" style={{ '--inquiry-color': t.color }} />
                  <div>
                    <strong style={{ color: t.color }}>{t.label}</strong> — {counts[t.id] || 0} papers
                    {t.description && <p className="about-page__inquiry-description">{t.description}</p>}
                  </div>
                </li>
              ))}
            </ul>
          </section>
        )}

        {(about.sections || []).map((section) => (
          <section className="detail-section" key={section.title}>
            <h2 className="detail-section__title">{section.title}</h2>
            <p>{section.content}</p>
          </section>
        ))}

        {about.license && (
          <section className="detail-section">
            <h2 className="detail-section__title">License</h2>
            <p className="about-page__license">
              {about.license.text}{' '}
              <a
                className="about-page__license-link"
                href={about.license.url}
                target="_blank"
                rel="noopener noreferrer license"
              >
                {about.license.fullName || about.license.name}
              </a>
            </p>

            {about.license.reference && (
              <p className="about-page__license">
                {about.license.reference.text}{' '}
                {about.license.reference.serviceUrl && (
                  <a
                    className="about-page__license-link"
                    href={about.license.reference.serviceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {about.license.reference.serviceLabel || about.license.reference.serviceUrl}
                  </a>
                )}
                {about.license.reference.contactEmail && (
                  <>
                    {' '}
                    (<a className="about-page__license-link" href={`mailto:${about.license.reference.contactEmail}`}>
                      {about.license.reference.contactName || about.license.reference.contactEmail}
                    </a>)
                  </>
                )}
              </p>
            )}

            {about.license.citation && (
              <>
                <h3 className="about-page__citation-title">Citation</h3>
                {about.license.citation.text && (
                  <p className="about-page__license">{about.license.citation.text}</p>
                )}
                {about.license.citation.bibtex && (
                  <pre className="about-page__citation">
                    <code>{about.license.citation.bibtex}</code>
                  </pre>
                )}
              </>
            )}

            {about.license.funding?.text && (
              <>
                <h3 className="about-page__citation-title">Funding</h3>
                <p className="about-page__license">{about.license.funding.text}</p>
              </>
            )}
          </section>
        )}

        <p className="about-page__count">Total papers indexed: {papers.length}</p>
      </main>
    </div>
  );
}
